import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PhiService implements OnDestroy {
  private readonly key = 'obscure_phi';

  public readonly obscure = new BehaviorSubject(
    localStorage.getItem(this.key) === 'true',
  );

  private subscription: Subscription;

  constructor() {
    this.subscription = this.obscure.subscribe((value: boolean) => {
      localStorage.setItem(this.key, value.toString());
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
